import { LoadState } from "../../constants/enums";
import { IWhatsAppTemplateBody, IWhatsAppTemplateButtons, IWhatsAppTemplateFooter, IWhatsAppTemplateHeader } from "../whatsappTemplate/whatsappTemplate.types";

export type CampaignRuleTemplateVariableType = "date" | "dropdown" | "multiselect_dropdown" | "number";

export interface ICampaignRuleTemplateVariableDetail {
  type: CampaignRuleTemplateVariableType;
  variable: string;
  options?: string[];
}

export interface ICampaignRuleTemplate {
  campaign_rule_template_uuid: string;
  market_campaign_rule_template_uuid?: string;
  module_name: string | null;
  template_name: string;
  template_description: string;
  template: string;
  mapping_keys: unknown | null;
  variables_details: ICampaignRuleTemplateVariableDetail[];
  campaign_rule?: ICampaignRule | null;
  template_sql: string;
  status: string;
  company_outlet_uuid: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
}

export interface IMarketCampaignLogs {
  company_outlet_uuid: string;
  company_outlet_name: string;
  name: string | null;
  status: "APPROVED" | "REJECTED" | "PENDING";
  reason: string | null;
  header: string | null;
  components: Array<
    | IWhatsAppTemplateBody
    | IWhatsAppTemplateHeader
    | IWhatsAppTemplateButtons
    | IWhatsAppTemplateFooter
  >;
  body: string | null;
  template_id: string | null;
  recipient_number?: string;
  recipient_name?: string;
}


export interface IMarketCampaignRuleTemplateState {
  list: {
    list: ICampaignRuleTemplate[];
    loading: LoadState;
    error: string | null;
  }
}


export interface IMarketCampaignState {
  marketCampainBasicInfo: {
    list: IMarketCampaignBasicInfo[];
    totalRecords: number;
    currentRecords: number;
    loading: LoadState;
    data: IMarketCampaignBasicInfo;
    dataLoading: LoadState;
    meta: {
      use_count: number;
      created_count: number;
    };
    error: string | null;
  };
  marketCampaignAudience: {
    list: IMarketCampaignAudience[];
    loading: LoadState;
    data: IMarketCampaignAudience;
    dataLoading: LoadState;
    error: string | null;
    totalRecords: number;
  };
  marketCampaignChannel: {
    list: IMarketCampaignChannel[];
    loading: LoadState;
    data: IMarketCampaignChannel;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampaignQuickSend: {
    list: IMarketCampaignQuickSendData[];
    headers: any[];
    loading: LoadState;
    data: IMarketCampaignQuickSendData;
    dataLoading: LoadState;
    error: string | null;
    totalRecords: number;
  };
  campaignSqlQueryResult: {
    list: IMarketCampaignQuickSendData[];
    loading: LoadState;
    data: IMarketCampaignQuickSendData;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampaignCronScheduler: {
    list: IMarketCampaignCronScheduler[];
    loading: LoadState;
    data: IMarketCampaignCronScheduler;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampaignRuleTemplate: {
    list: ICampaignRuleTemplate[];
    loading: LoadState;
    data: ICampaignRuleTemplate;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampaignLogs: {
    list: IMarketCampaignBasicInfo[];
    loading: LoadState;
    data: IMarketCampaignBasicInfo;
    dataLoading: LoadState;
    error: string | null;
  };
  marketCampaignDraftSteps: {
    list: IMarketCampaignDraftStep[];
    loading: LoadState;
    data: IMarketCampaignDraftStep;
    dataLoading: LoadState;
    error: string | null;
  };
  audienceListColumns: IAudienceListColumnState;
}
export interface IConditionTableRow {
  view: string;
  viewColumn: string;
  column: string;
  operant:
    | "EQUAL"
    | "NOT_EQUAL"
    | "GREATER"
    | "LESSER"
    | "GREATER_THAN_EQUAL"
    | "LESSER_THAN_EQUAL"
    | null;
  columnCompView: string | null;
  columnCompColumn: null;
  columnOrValue: string | null;
  compareColumnValue: string | null;
  isColumnComparison: boolean;
  isCompareWithOldValue: boolean;
}

export interface IMarketCampaignLogs {
  company_outlet_uuid: string;
  company_outlet_name: string;
  name: string | null;
  status: "APPROVED" | "REJECTED" | "PENDING";
  reason: string | null;
  header: string | null;
  components: Array<
    | IWhatsAppTemplateBody
    | IWhatsAppTemplateHeader
    | IWhatsAppTemplateButtons
    | IWhatsAppTemplateFooter
  >;
  body: string | null;
  template_id: string | null;
  recipient_number?: string;
  recipient_name?: string;
}
export interface IMarketCampain {
  market_campaign_uuid: string | null;
  module_name: string | null;
  module_uuid: string | null;
  campaign_name: string | null;
  description: string | null;
  campaign_time: string | null;
  market_campaign_rule_template_uuid: string | null;
  template_name: string | null;
  ui_module_name: string | null;
  // campaign_rule: {
  // 	[key: string]: {
  // 		rows: ICampaignConditionTableRow[];
  // 	};
  // }[];
  campaign_rule: ICampaignRule;
  channel_type: string | null;
  is_cron_set: number;
  cron_scheduler: {
    start_date: string;
    end_date: string;
    seconds: string;
    minutes: string;
    hours: string;
    week: string;
    repeatEvery: boolean;
  };
  channel_uuid: string | null;
  module_variables_columns_name: string[];
  module_channel_related_columns_name: string[];
  campaign_start_date: string | null;
  campaign_end_date: string | null;
  status: string | null;
  campaign_sql_rule: string;
  company_outlet_uuid: string;
  company_outlet_name: string;
  create_ts?: string | null;
  insert_ts?: string | null;
  modified_by_name?: string | null;
  modified_by_uuid?: string | null;
  created_by_name?: string | null;
  created_by_uuid?: string | null;
  read_ts?: string | null;
  send_ts?: string | null;
  delivered_ts?: string | null;
  total_audience?: number | null;
  sent_messages?: number | null;
  failed_messages?: number | null;
  read_messages?: number | null;
  delivered_messages?: number | null;
}

export type DurationType = "next" | "previous" | "";
export type DurationUnit = "Days" | "Weeks" | "Months" | "Years" | "";

export interface ICampaignRule {
  event_type: string[];
  status: string[];
  duration_type: DurationType;
  number_count: number;
  duration: DurationUnit;
  booking_end_period?: number;
  company_outlet_uuid?: string;
  refernce_column_name_value?: string[];
}

export interface ICampaignConditionTableRow {
  viewColumn: string;
  column: string;
  operant:
    | "EQUAL"
    | "NOT_EQUAL"
    | "GREATER"
    | "LESSER"
    | "GREATER_THAN_EQUAL"
    | "LESSER_THAN_EQUAL"
    | null;
  columnCompView: string | null;
  columnCompColumn: null;
  columnOrValue: string | null;
  compareColumnValue: string | null;
  isColumnComparison: boolean;
}

export type VariableType = "dropdown" | "multiselect_dropdown" | "number";

export interface VariableDetail {
  type: VariableType;
  variable: string;
  options?: string[];
}

export const initialMarketCampaignState: IMarketCampaignState = {
  marketCampainBasicInfo: {
    list: [],
    totalRecords: 0,
    currentRecords: 0,
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_unique_id: 0,
      market_campaign_uuid: "",
      campaign_name: "",
      campaign_description: null,
      status: "ACTIVE",
      company_outlet_uuid: "",
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      insert_ts: "",
      sending_type: "QUICK",
    },
    meta: {
      use_count: 0,
      created_count: 0,
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignAudience: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_audience_unique_id: 0,
      market_campaign_audience_uuid: null,
      market_campaign_uuid: "",
      audience_source: null,
      source_link: [],
      market_campaign_rule_template_uuid: "",
      market_campaign_rule_template_name: "",
      campaign_rule: {
        event_type: [],
        status: [],
        duration_type: "",
        number_count: 1,
        duration: "",
      },
      campaign_sql_rule: "",
      status: "ACTIVE",
      company_outlet_uuid: "",
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      insert_ts: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignChannel: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_channel_unique_id: 0,
      market_campaign_channel_uuid: null,
      market_campaign_uuid: "",
      market_campaign_channel_name: "",
      template_name: "",
      template_uuid: "",
      header_media: [],
      module_variables_columns_name: [],
      status: "ACTIVE",
      company_outlet_uuid: null,
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      insert_ts: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignQuickSend: {
    list: [],
    headers: [],
    loading: LoadState.NotLoaded,
    data: {
      email: null,
      status: "",
      event_time: "",
      event_type: "",
      leads_uuid: "",
      date_of_visit: "",
      followup_date: "",
      last_event_date: "",
      preferred_venue: "",
      phone: "",
      name: "",
      event_type_reminder: "",
      upcoming_event_date: "",
      check: 0,
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  campaignSqlQueryResult: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      email: null,
      status: "",
      event_time: "",
      event_type: "",
      leads_uuid: "",
      date_of_visit: "",
      followup_date: "",
      last_event_date: "",
      preferred_venue: "",
      name: "",
      phone: "",
      event_type_reminder: "",
      upcoming_event_date: "",
      check: 0,
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },

  marketCampaignCronScheduler: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_cron_scheduler_unique_id: 0,
      market_campaign_cron_scheduler_uuid: null,
      market_campaign_uuid: "",
      execution_type: "scheduled",
      cron_scheduler: {
        minutes: "",
        seconds: "",
        hours: "",
        end_date: "",
        start_date: "",
        repeatEvery: true,
      },
      status: "ACTIVE",
      company_outlet_uuid: null,
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      insert_ts: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignRuleTemplate: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      campaign_rule_template_uuid: "",
      market_campaign_rule_template_uuid: "",
      module_name: null,
      template_name: "",
      template_description: "",
      template: "",
      mapping_keys: null,
      variables_details: [],
      template_sql: "",
      status: "ACTIVE",
      company_outlet_uuid: "",
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      insert_ts: "",
      campaign_rule: {
        event_type: [],
        status: [],
        duration_type: "",
        number_count: 1,
        duration: "",
      },
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignLogs: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      market_campaign_unique_id: 0,
      market_campaign_uuid: "",
      campaign_name: "",
      campaign_description: null,
      status: "ACTIVE",
      company_outlet_uuid: "",
      created_by_uuid: "",
      created_by_name: "",
      modified_by_uuid: "",
      modified_by_name: "",
      create_ts: "",
      sending_type: "",
      insert_ts: "",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  marketCampaignDraftSteps: {
    list: [],
    loading: LoadState.NotLoaded,
    data: {
      draft_step_uuid: "",
      total_steps: 0,
      current_step: 0,
      draft_step_data: {},
      status: "ACTIVE",
    },
    dataLoading: LoadState.NotLoaded,
    error: null,
  },
  audienceListColumns: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
};

export const initialCampaignRuleTemplate: ICampaignRuleTemplate = {
  campaign_rule_template_uuid: "",
  market_campaign_rule_template_uuid: "",
  module_name: null,
  template_name: "",
  template_description: "",
  template: "",
  mapping_keys: null,
  variables_details: [],
  template_sql: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  campaign_rule: {
    event_type: [],
    status: [],
    duration_type: "",
    number_count: 1,
    duration: "",
  },
};

// Step 1 - Market Campaign Basic Info
export interface IMarketCampaignBasicInfo {
  market_campaign_unique_id: number;
  market_campaign_uuid: string;
  campaign_name: string;
  sending_type: string;
  campaign_description: string | null;
  status: string;
  company_outlet_uuid: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  campaign_start_date?: string;
  campaign_end_date?: string;
}

export interface IMarketCampaignDraftStep {
  draft_step_uuid: string;
  total_steps: number;
  current_step: number;
  draft_step_data: {
    step_one_data?: any;
    step_two_data?: any;
    step_three_data?: any;
    step_four_data?: any; // Replace with your step 4 data type
    template_data?: any;
  };
  is_upsell_generated?: number;
  status: "ACTIVE" | "INACTIVE";
}

export interface IAudienceListItem {
  check: number;
  name: string;
  phone: string;
  isRecordUpdated: boolean;
  initialCheck: number;
  currentPageNo: number;
}

export interface IAudienceDetails {
  uuid: string;
  check: boolean;
}

// Step 2 - Market Campaign Audience
export interface IMarketCampaignAudience {
  market_campaign_audience_unique_id?: number;
  market_campaign_audience_uuid?: string | null;
  market_campaign_uuid: string;
  audience_source: "EXCEL" | "DATABASE" | "CSV" | null;
  source_link: string[];
  market_campaign_rule_template_uuid: string;
  market_campaign_rule_template_name: string;
  campaign_rule: ICampaignRule | null;
  campaign_sql_rule?: string;
  status?: string;
  company_outlet_uuid: string;
  created_by_uuid?: string;
  created_by_name?: string;
  modified_by_uuid?: string;
  modified_by_name?: string;
  create_ts?: string;
  insert_ts?: string;
  market_campaign_audience_list_uuid?: string; // Keep for backward compatibility
  market_campaign_audience_list_uuids?: string[]; // New array structure
  market_campaign_audience_list?: IAudienceDetails[];
  audience_list?: IAudienceListItem[];
  audience_name?: string;
}

// Step 3 - Market Campaign Channel
export interface IMarketCampaignChannel {
  market_campaign_channel_unique_id: number;
  market_campaign_channel_uuid: string | null;
  market_campaign_uuid: string;
  market_campaign_channel_name: string;
  template_name: string;
  template_uuid: string;
  header_media: {
    type: string;
    value: string;
  }[];
  module_variables_columns_name: {
    type: string;
    value: string;
  }[];
  status: string;
  company_outlet_uuid: string | null;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
}

// Step 4 - Quick Send Data
export interface IMarketCampaignQuickSendData {
  email: string | null;
  status: string;
  event_time: string;
  event_type: string;
  leads_uuid: string;
  date_of_visit: string;
  followup_date: string;
  last_event_date: string;
  preferred_venue: string;
  phone: string;
  name: string;
  event_type_reminder: string;
  upcoming_event_date: string;
  check: number;

  //new for audience list
  market_campaign_audience_list_uuid?: string;

  audience_source?: "EXCEL" | "DATABASE" | "CSV" | null;
  source_link?: string[];
  campaign_rule?: ICampaignRule | null;
  market_campaign_rule_template_uuid?: string;
  market_campaign_rule_template_name?: string;
  market_campaign_audience_uuid?: string;
}

// Step 4 - Cron Scheduler
export interface IMarketCampaignCronScheduler {
  market_campaign_cron_scheduler_unique_id?: number;
  market_campaign_cron_scheduler_uuid?: string | null;
  execution_type?: "quick" | "scheduled" | null;
  market_campaign_uuid: string;
  cron_scheduler: {
    minutes: string;
    seconds: string;
    hours: string;
    end_date: string;
    start_date: string;
    repeatEvery: boolean;
    week?: string;
  } | null;
  status: string;
  company_outlet_uuid?: string | null;
  created_by_uuid?: string;
  created_by_name?: string;
  modified_by_uuid?: string;
  modified_by_name?: string;
  create_ts?: string;
  insert_ts?: string;
}

// Audience List Column Management
export interface IAudienceListColumn {
  audience_list_column_unique_id: number;
  audience_list_column_uuid: string;
  description: string;
  additional_columns: string[];
  company_outlet_uuid: string;
  status: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string | null;
  insert_ts: string;
  master_columns: string[];
}

export interface IAudienceListColumnState {
  data: IAudienceListColumn | null;
  loading: LoadState;
  error: string | null;
}

export const initialMarketCampaignChannel: IMarketCampaignChannel = {
  market_campaign_channel_unique_id: 0,
  market_campaign_channel_uuid: "",
  market_campaign_uuid: "",
  market_campaign_channel_name: "",
  template_name: "",
  template_uuid: "",
  header_media: [],
  module_variables_columns_name: [],
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export interface IMarketCampaignQuickSendList {
  market_campaign_quick_send_list_uuid: string | null;
  market_campaign_quick_send_list_unique_id?: number;

  company_outlet_uuid: string | null;
  market_campaign_uuid: string | null;

  incremental_number?: any;

  quick_send_list: {
    headers: string[];
    new_audience_added: IPhoneAudience[];
    audience_list_uuids: string[];
    selected_audience_list_operation: ISelectedAudienceOperation;
  };

  status: "ACTIVE" | "INACTIVE";

  created_by_uuid?: string;
  created_by_name?: string;
  modified_by_uuid?: string;
  modified_by_name?: string;

  create_ts?: string;
  insert_ts?: string;
}

export interface ISelectedAudienceOperation {
  chek: IPhoneAudience[];
  uncheck: IPhoneAudience[];
}

export interface IPhoneAudience {
  phone: string;
}

export const defaultMarketCampaignQuickSendList: IMarketCampaignQuickSendList =
  {
    market_campaign_quick_send_list_uuid: null,

    company_outlet_uuid: null,
    market_campaign_uuid: null,

    quick_send_list: {
      headers: [],
      new_audience_added: [],
      audience_list_uuids: [],
      selected_audience_list_operation: {
        chek: [],
        uncheck: [],
      },
    },
    status: "ACTIVE",
  };
